import { useRegisterRuleGroup } from './rule-group-registration-context';
export const SectionDividerRuleGroup = _ref => {
  let {
    children,
    ...ruleGroup
  } = _ref;
  useRegisterRuleGroup(ruleGroup);
  return null;
};
//# sourceMappingURL=section-divider-rule-group.js.map